import { render, staticRenderFns } from "./modalTermoCompromisso.vue?vue&type=template&id=1ffb896c&scoped=true&lang=pug&"
import script from "./modalTermoCompromisso.vue?vue&type=script&lang=js&"
export * from "./modalTermoCompromisso.vue?vue&type=script&lang=js&"
import style0 from "./modalTermoCompromisso.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./modalTermoCompromisso.vue?vue&type=style&index=1&id=1ffb896c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffb896c",
  null
  
)

export default component.exports